import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustMarquee from "@/components/TrustMarquee";
import About from "@/components/About";
import Capabilities from "@/components/Capabilities";
import Fleet from "@/components/Fleet";
import ExportProcess from "@/components/ExportProcess";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import { Toaster } from "@/components/ui/sonner";

const Home = () => {
  return (
    <div className="relative bg-[#0A0A0A] min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      {/* SVG filter: keeps amber + black, drops the white JPG background */}
      <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
        <defs>
          <filter id="trom-remove-white" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      -1 -1 -1 3 0"
            />
          </filter>
        </defs>
      </svg>
      <Navbar />
      <Hero />
      <TrustMarquee />
      <Fleet />
      <ExportProcess />
      <About />
      <Capabilities />
      <Contact />
      <Footer />
      <StickyMobileCTA />
      {/* Mobile bottom padding so sticky CTA doesn't cover footer */}
      <div className="md:hidden h-16" />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </LanguageProvider>
  );
}

export default App;
